import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

import numberFormatterMod from 'accounting';

//Had to hack this because webpack changes module names to minimize file size
const numberFormatter = numberFormatterMod;

const findDependants = (questionList, answers) => {
  return questionList.reduce((retVal, question) => {
    const matchedDep = question.dependencies.find((dep) => answers.includes(dep.FK_answerKey));
    if (matchedDep) {
      question.timer = matchedDep.timer;
      retVal.push(question);
    }
    return retVal;
  }, []);
};

const allowSimReEntry = (simsettings) => {
  return (
    simsettings !== null &&
    Object.keys(simsettings).length > 0 &&
    simsettings.allowReEntryInbox !== undefined
  );
};

const nextTimestamp = () => dayjs().format('[Today], h:mm a');

const nextClockTimestamp = (h, m, additionalTime) =>
  'Today'+dayjs()
    // .day(4)
    .hour(h)
    .minute(+m + additionalTime)
    .format(', h:mm a');

const generateTimestamp = (length, idx) => {
  const timestamp = dayjs()
    .startOf('week')
    .subtract(2, 'day')
    .add(8, 'h')
    .add(idx * (1500000 - idx * 1000), 'ms')
    .format('ddd, h:mm a');
  return timestamp;
};

const generateClockTimestamp = (length, sequence, timeDelay, h = 8, m = 30) => {
  let timestamp = '';
  if (timeDelay > 0) {
    let additionalTime = Math.floor(timeDelay / (60 * 1000));
    let additionalMin = additionalTime % 60; // min
    let additionalHour = Math.floor(additionalTime / 60); // hour
    timestamp = nextClockTimestamp(h + additionalHour, m, additionalMin);
  } else {
    timestamp = dayjs({ day: 4, hour: 8, minute: 30 })
      .add((length - sequence) * (1400000 - sequence * 30000), 'ms')
      .format('ddd, h:mm a');
  }

  return timestamp;
};

const convertUTCtoLocal = (time) => {
  return dayjs(time).format('ddd, h:mm a');
};

const getTimestampAllowReEntryInbox = (
  email,
  idx,
  today,
  emailsLength,
  postAssessment,
  versionConfig
) => {
  let timestamp;
  const hasNoDeps = email.dependsOn == null && email.dependencies.length === 0;
  const hasNoTimer = email.timer === 0 || email.timer === null;
  let minutes = versionConfig.startTime - Math.floor(versionConfig.startTime);
  let hours = versionConfig.startTime - minutes;

  if (hasNoDeps && hasNoTimer) {
    if (versionConfig.showTimerAsClock && email.FK_questionDisplayTypeKey === 2) {
      timestamp = nextClockTimestamp(hours, minutes * 60, 0);
    } else {
      timestamp = generateTimestamp(emailsLength, idx);
    }
  } else {
    timestamp = null;
  }

  if (versionConfig.showTimerAsClock) {
    // !timestamp => filter out any initially created emails
    if (!timestamp) {
      timestamp = generateClockTimestamp(emailsLength, idx, email.timer, hours, minutes * 60);
    }
  } else {
    // !timestamp => filter out any initially created emails
    if (!timestamp) {
      // filter out any non-delivered emails
      if (email.timestamp) {
        if (today.isSame(dayjs(email.timestamp), 'day')) {
          timestamp = dayjs(email.timestamp).format('[Today], h:mm a');
        } else {
          timestamp = convertUTCtoLocal(email.timestamp);
        }
      }
    }
  }

  return timestamp;
};

const parseEmails = (data, { postAssessment }, versionConfig, simsettings) => {
  
  const emailsLength = data.emails.length;
  const evalRegex = /####.*?####/g;
  const advancedReport = data.advancedReport;
  const simulationReport = data.simulationReport;
  const dayjsToday = dayjs();
  const isSimReEntry = allowSimReEntry(simsettings);

  const allowReEntry = versionConfig.allowReEntryInbox || isSimReEntry;
  let emailsToParse;
  if (versionConfig?.isRandomizeAnswers) {
    emailsToParse = data.emailsAnsShuffled;
  } else {
    emailsToParse = data.emails;
  }
  if (numberFormatter == 'random' && simulationReport =="random" && advancedReport =="random" && numberFormatter.formatMoney == "random") console.log('random');
  return emailsToParse
    .sort((a, b) => a.sequence - b.sequence)
    .sort((a, b) => a.timer - b.timer)
    .map((elem, idx) => {
      const hasNoDeps = elem.dependsOn == null && elem.dependencies.length === 0;
      const hasNoTimer = elem.timer === 0 || elem.timer === null;

      // temporary 'allowReEntryInbox' logic for next sprint
      let timestamp;
      if (allowReEntry) {
        timestamp = getTimestampAllowReEntryInbox(
          elem,
          idx,
          dayjsToday,
          emailsLength,
          postAssessment,
          versionConfig
        );
      } else {
        timestamp = !postAssessment
          ? hasNoDeps && hasNoTimer
            ? generateTimestamp(emailsLength, idx)
            : null
          : hasNoDeps && hasNoTimer
          ? generateClockTimestamp(emailsLength, elem.sequence, 0)
          : null;
      }

      const userActivities = elem.userActivityStatus;
      Object.assign(elem, {
        isRead: userActivities && userActivities.isEmailRead ? userActivities.isEmailRead : false,
        isFlagged:
          userActivities && userActivities.isEmailFlagged ? userActivities.isEmailFlagged : false,
        timestamp,
      });

      // Evaluates dynamic content
      elem.answers.map((answer) => {
        const answerText = answer.nameTagKey;
        if (answerText) {
          try {
            let mathces = answer.nameTagKey.match(evalRegex);
            if (mathces != null) {
              for (let i = 0; i < mathces.length; i++) {
                let temp = mathces[i].replace(/####/g, '');
                answer.nameTagKey = answer.nameTagKey.replace(mathces[i], eval(temp));
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
        return answer;
      });

      // Evaluates dynamic content
      if (elem.answer) {
        elem.answer.map((answer) => {
          const answerText = answer.nameTagKey;
          if (answerText) {
            try {
              let mathces = answer.nameTagKey.match(evalRegex);
              if (mathces != null) {
                for (let i = 0; i < mathces.length; i++) {
                  let temp = mathces[i].replace(/####/g, '');
                  answer.nameTagKey = answer.nameTagKey.replace(mathces[i], eval(temp));
                }
              }
            } catch (error) {
              console.log(error);
            }
          }
          return answer;
        });
      }

      let mathces = elem.descriptionTagKey.match(evalRegex);
      if (mathces != null) {
        try {
          for (let i = 0; i < mathces.length; i++) {
            let temp = mathces[i].replace(/####/g, '');
            elem.descriptionTagKey = elem.descriptionTagKey.replace(mathces[i], eval(temp));
          }
        } catch (error) {
          console.log(error);
        }
      }

      return elem;
    });
};

const parseMessages = (data, { firstname }, versionConfig, simsettings) => {
  const messagesLength = data.messages.length;
  const dayjsToday = dayjs();
  const isSimReEntry = allowSimReEntry(simsettings);
  const allowReEntry = versionConfig.allowReEntryInbox || isSimReEntry;

  let parsedMessages;
  if (versionConfig.isRandomizeAnswers) {
    parsedMessages = data.messagesAnsShuffled;
  } else {
    parsedMessages = data.messages;
  }

  return parsedMessages.map((elem, idx) => {
    elem.descriptionTagKey = elem.descriptionTagKey.replace(/{name}/g, `${firstname}`);
    let timestamp;
    if (allowReEntry) {
      timestamp = getTimestampAllowReEntryInbox(
        elem,
        idx,
        dayjsToday,
        messagesLength,
        false,
        versionConfig
      );
      Object.assign(elem, { isSent: false, timestamp });
    } else {
      Object.assign(elem, { isSent: false });
    }

    return elem;
  });
};

const parseData = (data, userData, versionConfig, simsettings = {}) => {
  data.emails = parseEmails(data, userData, versionConfig, simsettings);
  data.messages = parseMessages(data, userData, versionConfig, simsettings);
  data.folders.forEach((elem) => (elem.isOpen = false));
  return data;
};

const findDeliveriesFromList = (itemList, elapsedTime, deliveredEmailLog) => {
  return itemList.filter((email) => {
    const isReadyToDeliver = email.timer <= elapsedTime;
    // We check against the log in case an user has answered an email already but then exited out of their tab and reentered
    const notDeliveredInPrevVisit = deliveredEmailLog.indexOf(email.questionKey) === -1;
    return isReadyToDeliver && !email.isDelivered && notDeliveredInPrevVisit;
  });
};

const getTimestamp = (showTimerAsClock, clockTimer) => {
  return showTimerAsClock
    ? nextClockTimestamp(clockTimer.hour, clockTimer.minutes, 0)
    : nextTimestamp();
};

// temporary 'allowReEntryInbox' logic for next sprint
const getTimestampForMessage = (showTimerAsClock, clockTimer, allowReEntryInbox) => {
  // Separate the logic for next sprint
  if (allowReEntryInbox) {
    return showTimerAsClock
      ? nextClockTimestamp(clockTimer.hour, clockTimer.minutes, 0)
      : nextTimestamp();
  } else {
    return showTimerAsClock
      ? nextClockTimestamp(clockTimer.hour, clockTimer.minutes, 0)
      : nextTimestamp();
  }
};

export {
  parseData,
  generateTimestamp,
  getTimestamp,
  getTimestampForMessage,
  findDependants,
  findDeliveriesFromList,
  convertUTCtoLocal,
  allowSimReEntry,
};
